import AppsContainer from "@lib/components/AppComponents/AppsContainer";
import { useIntl } from "react-intl";
import ChatSideBar from "./ChatSideBar";
import ChatContent from "./ChatContent";

export default function TelegramMessages() {
  const { messages } = useIntl();

  return (
    <AppsContainer
      title={messages["common.telegram"] as string}
      sidebarContent={<ChatSideBar />}
    >
      <ChatContent />
    </AppsContainer>
  );
}
